'use client'

import {
	ToastContainer as ToastifyContainer,
	cssTransition,
} from 'react-toastify'
import styled, { keyframes } from 'styled-components'

const ANIMATION_DURATION = '0.3s'

const animations = {
	slideIn: keyframes`
		0% { transform: translateY(100%); opacity: 0; }
		100% { transform: translateY(0); opacity: 1; }
	`,
	slideOut: keyframes`
		0% { transform: translateY(0); opacity: 1; }
		100% { transform: translateY(100%); opacity: 0; }
	`,
	progressBar: keyframes`
		0% { transform: scaleX(1); }
		100% { transform: scaleX(0); }
	`,
}

export const SlideAnimation = cssTransition({
	enter: 'slide-in',
	exit: 'slide-out',
})

export const ToastContainer = styled(ToastifyContainer)`
	&&&.Toastify__toast-container {
		z-index: ${(props) => props.theme.zIndexes.toast};
		position: fixed;
		padding: 1rem;
		width: 75%;
		left: 50%;
		bottom: 5rem;
		transform: translate(-50%, 0);
		display: flex;
		flex-direction: column-reverse;
		gap: 0.5rem;

		${(props) => props.theme.deviceBreakpoints.tablet} {
			width: 22.5rem;
		}

		${(props) => props.theme.deviceBreakpoints.desktop} {
			left: auto;
			right: 5rem;
			transform: none;
		}
	}

	.Toastify__toast {
		position: relative;
		margin: 0;
		min-height: 3rem;
		box-shadow: ${(props) => props.theme.shadows.default};
	}

	.Toastify__toast-body {
		padding: 0;
	}

	.slide-in {
		animation: ${animations.slideIn} ${ANIMATION_DURATION}
			cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
	}

	.slide-out {
		animation: ${animations.slideOut} ${ANIMATION_DURATION}
			cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
	}

	.Toastify__progress-bar {
		animation: ${animations.progressBar} linear 1 forwards;
	}

	.Toastify__toast--stacked {
		position: absolute;
		width: 100%;
		/* TODO: These variables are from the Toastify library */
		transform: translate3d(0, var(--y), 0) scale(var(--s));
		transition: transform ${ANIMATION_DURATION} cubic-bezier(0.2, 0, 0, 1);
	}

	.Toastify__toast--stacked[data-collapsed] {
		.Toastify__toast-body,
		.Toastify__close-button {
			transition: opacity 0.1s;
		}
	}

	.Toastify__toast--stacked[data-collapsed='false'] {
		overflow: visible;
	}

	.Toastify__toast--stacked[data-collapsed='true']:not(:last-child) {
		transform: translate3d(0, -0.75rem, 0) scale(0.95);
	}

	.Toastify__toast--stacked:after {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		/* TODO: These variables are from the Toastify library */
		height: calc(var(--g) * 1px);
		bottom: 100%;
	}
`
